import { render } from "./PlanCategoryDetail.vue?vue&type=template&id=3b72181f"
import script from "./PlanCategoryDetail.vue?vue&type=script&lang=js"
export * from "./PlanCategoryDetail.vue?vue&type=script&lang=js"

import exportComponent from "D:\\VueProject\\everlife-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__